<a class="suport-button" (click)="callNow()">
  <h3 class="suport-button__title">¿Tienes alguna duda?</h3>
</a>